// extracted by mini-css-extract-plugin
export default {"slideshow":"SlideShow_slideshow__NlMxb","slide":"SlideShow_slide__T1Y+k"};